import { FC } from 'react';

interface IconProps {
  width?: string | number;
  height?: string | number;
}

const ConnectionXdsl: FC<IconProps> = ({ width, height }) => {
  return (
    <img
      alt="xdsl"
      src="https://cdn.o2.cz/mojeo2-product/front-end/icon-connection-dsl.svg"
      width={width}
      height={height}
    />
  );
};

export default ConnectionXdsl;
